import * as React from 'react';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { NvMarkdownInline, NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import classes from './BannerBlock.module.esm.js';

var BannerBlock = function (_a) {
    var _b;
    var id = _a.id, _c = _a.fields, fullWidth = _c.fullWidth, internalName = _c.internalName, heading = _c.heading, link = _c.link, body = _c.body, theme = _c.theme, analyticsEvents = _c.analyticsEvents, dataCy = _a["data-cy"];
    var className = classNames(classes.root, (_b = {},
        _b[classes[theme]] = theme,
        _b[classes.noBodyRoot] = !body,
        _b[classes.notFullWidth] = !fullWidth,
        _b[classes.fullWidth] = fullWidth,
        _b['nv-container'] = !fullWidth,
        _b));
    var buttonClassName = classNames('nv-button', classes.button);
    return (React.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: className, "data-cy": dataCy, id: id, sectionName: internalName },
        React.createElement("div", { className: classNames({ 'nv-container': fullWidth }) },
            React.createElement("div", null,
                React.createElement(NvMarkdownInline, { className: classes.heading, elementWrapper: "h2" }, heading)),
            body && React.createElement(NvMarkdown, { className: classes.body }, body),
            React.createElement("div", null, link && React.createElement(BaseNucleobaseComponent, { classes: { link: buttonClassName }, source: link })))));
};

export { BannerBlock as default };
//# sourceMappingURL=BannerBlock.esm.js.map
